import RouteKey from '@/common/RouteKey';
export default {
  carouselItems: [
    {
      template: 'default',
      config: {
        title: '腾讯云xDeepSeek：率先上线最新版V3模型API',
        title1: '接口、大模型知识引擎内置新模型服务',
        desc1: '3月25日晚，腾讯云率先上线DeepSeek-V3-0324版本，',
        desc2: '企业和开发者可以通过腾讯云直接调用新版模型的API接口，获得稳定优质的服务。',
        backgroundImageUrl: require('../imgs/head-banner/banner_opensourse.jpg')
      },
      actionTransferUrl: RouteKey.OPEN_NEWS_72
    }, {
      template: 'default',
      config: {
        title: 'CVPR 2025',
        title1: '腾讯优图实验室22篇论文入选',
        desc1: '近日， CVPR 2025（IEEE/CVF Conferenceon on Computer Vision and Pattern Recognition）',
        desc2: '论文录用结果揭晓，本次大会共2878篇被录用，录用率为22.1%。',
        backgroundImageUrl: require('../imgs/head-banner/banner_academic.jpg')
      },
      actionTransferUrl: RouteKey.OPEN_NEWS_82
    }, {
      template: 'default',
      config: {
        title: 'ICLR 2025',
        title1: '腾讯优图实验室6篇论文入选',
        desc1: '近日，第 13 届 ICLR（International Conference on Learning Representations）',
        desc2: '国际学习表征会议公布了论文录用结果。',
        backgroundImageUrl: require('../imgs/head-banner/banner_academic.jpg')
      },
      actionTransferUrl: RouteKey.OPEN_NEWS_81
    }, {
      template: 'default',
      config: {
        title: 'ICASSP 2025',
        title1: '腾讯优图实验室4篇论文入选',
        desc1: '近期，ICASSP（International Conference on Acoustics, Speech, and Signal Processing）',
        desc2: '2025会议公布了论文录用结果。',
        backgroundImageUrl: require('../imgs/head-banner/banner_academic.jpg')
      },
      actionTransferUrl: RouteKey.OPEN_NEWS_80
    }, {
      template: 'default',
      config: {
        title: '走进“机器外脑”时代',
        title1: '腾讯联合上海交通大学发布大模型时代的AI十大趋势',
        desc1: '报告基于科技行业发展、以及腾讯在AI领域的实践，',
        desc2: '从技术、应用、社会三个方面预测AI给经济社会带来的影响，通过10个关键性趋势勾勒出一个由大模型驱动的新未来。',
        backgroundImageUrl: require('../imgs/head-banner/banner_machine_bg.jpg')
      },
      actionTransferUrl: RouteKey.OPEN_NEWS_67
    }, {
      template: 'default',
      config: {
        title: '火热报名中',
        title1: '第五届Light创造营邀你一起破茧成光！',
        desc1: '本届Light创造营面向高校学生群体，',
        desc2: '围绕AI+社会公益议题（不限方向），征集技术公益解决方案。',
        backgroundImageUrl: require('../imgs/head-banner/banner_marketing.jpg')
      },
      actionTransferUrl: RouteKey.OPEN_NEWS_77
    }, {
      template: 'default',
      config: {
        title: '视频位',
        desc1: '腾讯优图品牌视频',
        backgroundImageUrl: require('../imgs/head-banner/banner_youto_video.jpg'),
        videoFlag: true
      },
      actionTransferUrl: null
    }],
  news: [{
    actionTransferUrl: true,
    desc: '腾讯优图AI开放平台将于2021年12月31号下线所有产品的API接口调用服务及开发者中心页面，相关服务已上线至腾讯云官网，请尽快迁移，给您带来的不便敬请谅解。'
  }]
};



// WEBPACK FOOTER //
// ./src/components/open/panels/home/config/index.js